import * as React from "react";
import {
  List,
  ListItem,
  Card as MuiCard,
  Typography,
  Box,
  Grid,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
import HelpSupportIcon from "../Icons/HelpSupportIcon";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import AboutCommunity from "./aboutCommunity";
import { useLocation } from "react-router-dom";

function DiscoverCommunity() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const { singleProgram } = useSelector((state: RootState) => state.programReducer);
  const [communities, setcommunities] = React.useState(singleProgram?.communities);
  const [selectedCommunity, setSelectedCommunity]=React.useState({});
  const handleSelectedCommunity=(data)=>{
    setSelectedCommunity(data)
  }
  const handleAboutCommunity=(data)=>{
    setSelectedCommunity({})
  }

  return (
    <>  
      {Object.keys(selectedCommunity).length > 0 ? (
      <AboutCommunity community={selectedCommunity} handleAboutCommunity={handleAboutCommunity}/>
    ) : (
      <div className={classes.container}>
        <MuiCard className={classes.card}>
          <Box className={classes.header}>
            <Link  to={isAdmin ? "/admin/dashboard" : "/user/dashboard"}>
              <img src={backIcon} alt="Back" className={classes.backIcon} />
            </Link>
            <img src={logo} alt="Logo" className={classes.logo} />
          </Box>
          <Box className={classes.pagetitle}>
            <Typography variant="h5" className={classes.communityHeading}>
              Discover Communities
            </Typography>
          </Box>

          <List className={classes.settingsList}>
            {communities.map((post) => (
              <ListItem className={classes.listItem}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <HelpSupportIcon width={50} height={50} />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={9}
                    md={10}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      variant="h3"
                      style={{ marginTop: "20px", cursor: "poiner" }}
                      onClick={() =>handleSelectedCommunity(post)
                      }
                    >
                      {post?.communityName}
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            ))}
          </List>
        </MuiCard>
      </div>
    )}

    </>
  );
}

export default DiscoverCommunity;
